function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6135",
  "data-name": "Group 6135",
  transform: "translate(-684.634 -426.854)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Man_4326500",
  transform: "translate(853.635 581.104)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3497",
  "data-name": "Path 3497",
  d: "M11.274,18.15l.137.41a.4.4,0,0,0,.379.274h.42a.4.4,0,0,0,.379-.274l.137-.41L12,17.55Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3498",
  "data-name": "Path 3498",
  d: "M10.1,14.687l1.9,1.9,1.9-1.9V13.94a4.619,4.619,0,0,1-2.465.385,4.88,4.88,0,0,1-1.341-.37Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3499",
  "data-name": "Path 3499",
  d: "M9.387,14.971a.025.025,0,0,0-.034,0l-.691.691,1.2,2.707a.023.023,0,0,0,.017.014.027.027,0,0,0,.021,0l1.576-1.314Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3500",
  "data-name": "Path 3500",
  d: "M14.614,14.972l-2.093,2.092L14.1,18.378a.022.022,0,0,0,.021,0,.019.019,0,0,0,.016-.014l.424-.951.78-1.755-.691-.691a.023.023,0,0,0-.036.005Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3501",
  "data-name": "Path 3501",
  d: "M88.577,87.428,71.924,81.545a1.859,1.859,0,0,0-.458-.785l-4.54-4.535a3.824,3.824,0,0,0-2.833-1.117V71.422a24.8,24.8,0,0,0,7.9-8.011,25.47,25.47,0,0,0,2.891-6.673,25.733,25.733,0,0,0,.874-6.673c0-16.169,0-15.916-.042-16.58a1.912,1.912,0,1,0-3.8.374c.042.432,0,.806,0,16.206a21.692,21.692,0,1,1-43.385,0c0-4.266-.045-7.495-.061-10.117a9.707,9.707,0,0,1,12.013-9.517c8.838,2.107,12.393,7.631,23.7,7.1a1.909,1.909,0,1,0-.179-3.813c-10.244.479-12.993-4.682-22.647-7A13.52,13.52,0,0,0,24.676,40c0,1.907.037,4.213.053,6.984a3.94,3.94,0,0,1-2.138-3.487V20.261a4.535,4.535,0,0,1,4.529-4.529,1.907,1.907,0,0,0,1.77-1.2A16.975,16.975,0,0,1,44.727,3.813H60.969A17.185,17.185,0,0,1,78.134,20.977V43.493a1.907,1.907,0,1,0,3.813,0V20.977A21,21,0,0,0,60.969,0H44.727a20.756,20.756,0,0,0-18.9,12.019,8.358,8.358,0,0,0-7.063,8.242V43.493a7.789,7.789,0,0,0,5.994,7.542c.053,0,.132,1.833.153,2.017q.121,1.011.316,2.007a25.028,25.028,0,0,0,1.085,3.85,25.533,25.533,0,0,0,3.808,6.847A25.854,25.854,0,0,0,35.763,71.1c.279.19.59.332.88.527v3.518A3.829,3.829,0,0,0,33.8,76.262L29.264,80.8a1.849,1.849,0,0,0-.458.79l-14.183,5-3.687,1.375A13.757,13.757,0,0,0,3.009,100.4v24.174a1.854,1.854,0,0,0,3.687,0V100.4a10.059,10.059,0,0,1,.648-3.534l9.364,7.995a6.051,6.051,0,0,1,2.107,4.6v15.079a1.854,1.854,0,1,0,3.687,0V109.464a9.764,9.764,0,0,0-3.408-7.416L9.282,93.637a10.007,10.007,0,0,1,4.082-2.718l16.506-5.825L35.71,98.261a3.8,3.8,0,0,0,2.633,2.175,3.9,3.9,0,0,0,.88.105,3.824,3.824,0,0,0,2.444-.89l1.8-1.5.263.79a5.841,5.841,0,0,0,1.622,2.475l-3.8,22.847a1.854,1.854,0,0,0,1.522,2.107,2.055,2.055,0,0,0,.305,0,1.859,1.859,0,0,0,1.828-1.548l3.65-21.973h2.965l3.687,21.973a1.849,1.849,0,0,0,1.822,1.548,2,2,0,0,0,.305,0,1.849,1.849,0,0,0,1.522-2.107l-3.818-22.842a5.793,5.793,0,0,0,1.633-2.481l.258-.785,1.8,1.5a3.771,3.771,0,0,0,2.438.89,3.834,3.834,0,0,0,3.513-2.275l2.191-4.935h0l.616-1.38h0L70.8,85.105l16.532,5.841a10.007,10.007,0,0,1,4.076,2.712l-9.812,8.427a9.754,9.754,0,0,0-3.413,7.416v15.079a1.854,1.854,0,1,0,3.687,0v-15.11a6.067,6.067,0,0,1,2.107-4.6l9.364-8.021a9.922,9.922,0,0,1,.648,3.534v24.169a1.854,1.854,0,1,0,3.687,0V100.379a13.746,13.746,0,0,0-9.1-12.951Zm-33.8-12.235a25.143,25.143,0,0,0,5.614-1.78v3.934L50.362,87.375,40.355,77.368v-3.85a25.7,25.7,0,0,0,7.063,1.949,25.054,25.054,0,0,0,7.358-.263ZM39.3,96.792a.142.142,0,0,1-.111,0,.121.121,0,0,1-.09-.074l-6.32-14.257,3.639-3.639a.132.132,0,0,1,.179,0L47.618,89.845Zm14.146.959a2.107,2.107,0,0,1-2,1.443H49.24a2.107,2.107,0,0,1-2-1.443l-.722-2.159,3.824-3.16,3.824,3.16Zm10.375-6.015-2.233,5.009a.1.1,0,0,1-.084.074.116.116,0,0,1-.111,0L53.09,89.9,64.114,78.88a.121.121,0,0,1,.179,0l3.639,3.639Z",
  transform: "translate(0 -102.587)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(890.354 504.686)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M19.5,2A17.5,17.5,0,1,0,37,19.5,17.5,17.5,0,0,0,19.5,2Zm9.933,14.415-10.5,9.625a1.75,1.75,0,0,1-2.42-.052l-5.25-5.25a1.75,1.75,0,1,1,2.475-2.475L17.8,22.328l9.265-8.493a1.75,1.75,0,0,1,2.366,2.58Z",
  transform: "translate(-47 -79.832)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Cross_2135404",
  transform: "translate(930.607 419.854)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3438",
  "data-name": "Path 3438",
  d: "M17.5,0h0A17.5,17.5,0,0,0,0,17.5H0A17.5,17.5,0,0,0,17.5,35h0A17.5,17.5,0,0,0,35,17.5h0A17.5,17.5,0,0,0,17.5,0Zm6,20.986c.893.839,1.2,1.836.281,2.772s-1.914.651-2.773-.233l-3.56-3.664c-1.253,1.333-2.345,2.509-3.454,3.67-.852.893-1.859,1.156-2.771.217s-.588-1.93.3-2.772c1.131-1.073,2.26-2.147,3.855-3.663-1.373-1.162-2.611-2.177-3.8-3.239-.957-.853-1.315-1.907-.282-2.885.957-.9,1.946-.533,2.773.35,1.064,1.135,2.123,2.275,3.445,3.691,1.367-1.459,2.457-2.644,3.569-3.81a1.719,1.719,0,0,1,2.65-.226c.949.905.714,1.909-.179,2.769-1.159,1.115-2.336,2.209-3.769,3.562C21.153,18.8,22.33,19.887,23.5,20.986Z",
  transform: "translate(-3 7)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6094",
  "data-name": "Group 6094",
  transform: "translate(-98.627 110.342)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3425",
  "data-name": "Path 3425",
  d: "M11095,20312.166h50.163",
  transform: "translate(-10207.999 -19874.453)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3427",
  "data-name": "Path 3427",
  d: "M11187.423,20279.7l7.117,7.258-7.117,7.645",
  transform: "translate(-10255.641 -19849.434)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6096",
  "data-name": "Group 6096",
  transform: "translate(16.441 -1.896)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_5417",
  "data-name": "Rectangle 5417",
  transform: "translate(668.192 505)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("rect", {
  width: 87,
  height: 98,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 84,
  height: 95,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3490",
  "data-name": "Path 3490",
  d: "M9693.379,17711.166h64.514",
  transform: "translate(-9013.929 -17189.771)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3491",
  "data-name": "Path 3491",
  d: "M9693.379,17711.166h64.514",
  transform: "translate(-9013.929 -17179.143)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3492",
  "data-name": "Path 3492",
  d: "M9693.379,17711.166h32.257",
  transform: "translate(-9013.929 -17158.85)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3493",
  "data-name": "Path 3493",
  d: "M9693.379,17711.166h32.257",
  transform: "translate(-9013.929 -17148.221)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3494",
  "data-name": "Path 3494",
  d: "M9693.379,17711.166h32.257",
  transform: "translate(-9013.929 -17137.59)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3495",
  "data-name": "Path 3495",
  d: "M9693.379,17711.166h32.257",
  transform: "translate(-9013.929 -17125.543)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 44,
  height: 45,
  transform: "translate(709.192 547)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-697.131,18.82-706.768,9.2V36.032a1.4,1.4,0,0,1-1.4,1.4h-.008a1.4,1.4,0,0,1-1.4-1.4V9.2L-719.2,18.82a1.4,1.4,0,0,1-1.974,0h0a1.4,1.4,0,0,1,0-1.974l12.021-12.021a1.4,1.4,0,0,1,1.979,0l12.021,12.021a1.4,1.4,0,0,1,0,1.974h0A1.4,1.4,0,0,1-697.131,18.82Z",
  transform: "translate(1439.032 548.747)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M9693.379,17711.166h64.514",
  transform: "translate(-9013.929 -17168.514)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6134",
  "data-name": "Group 6134",
  transform: "translate(-1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3511",
  "data-name": "Path 3511",
  d: "M18418.617,21139.354h28.813s-.91-10.875-9.158-14.232-16.687,1.383-18.787,7.547",
  transform: "translate(-17527 -20694.844)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3512",
  "data-name": "Path 3512",
  d: "M18418.617,21145.467s5.352,9.256,13.711,8.912,11.949-4.3,14.229-8.912",
  transform: "translate(-17527 -20694.844)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
})));

function SvgStepper5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277.974,
    height: 178.293,
    viewBox: "0 0 277.974 178.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper5);
export default __webpack_public_path__ + "static/media/stepper5.c69ed7502ff894d3427678adf1c8277e.svg";
export { ForwardRef as ReactComponent };